import { useAtom }             from "jotai";
import { useEffect, useState } from "react";

import { useGetLoggedIn }     from "_common/hooks/auth";
import {
	useGetIsUploadingVideo,
	useGetPercentCompletedAtom
} from "_common/hooks/uploadVideo";
import Toast                 from "_common/toast";
import { isNumeric }         from "_common/utils";
import { useSetModerators }  from "_components/pages/studio/states";
import { followersAtom }     from "_jotai/userProfile";
import { getModeratorsList } from "_services/api/broadcast";

import Presentation from "./presentation";

const UserProfileNew = props => {
	const {
		broadcastDetails,
		profile,
		// ugcStats, // check if we really need this
		userId,
		activeTab,
		activeTabData
	} = props;

	const [ showModeratorModal, setShowModeratorModal ] = useState ( false );

	const [ isModerator, setIsModerator ] = useState ( false );
	const [ errorModal, setErrorModal ]   = useState ( false );
	const [ , setFollowers ]              = useAtom ( followersAtom );

	const isUploadingVideo  = useGetIsUploadingVideo ();
	const percentCompleted  = useGetPercentCompletedAtom ();
	const isLoggedInUser    = useGetLoggedIn ();
	const setModeratorsList = useSetModerators ();

	useEffect ( () => {
		if ( !isLoggedInUser ) {
			return;
		}
		checkModeratorStatus ( userId );
	}, [ isLoggedInUser, userId ] );

	useEffect ( () => {
		if ( !profile ) return;

		setFollowers ( profile?.follow?.followers );

	}, [ profile ] );

	const checkModeratorStatus = async userId => {
		try {
			const res = await getModeratorsList ( { pageNo: 1, pageSize: 10 } );

			setModeratorsList ( res );

			if ( res.some ( e => e.id === parseInt ( userId ) ) ) {
				setIsModerator ( true );
			} else {
				setIsModerator ( false );
			}

		} catch ( error ) {
			Toast.error ( "Unable to fetch Moderators List" );
		}
	};

	const toggleModeratorOption = () => {
		setIsModerator ( prev => !prev );
	};

	const toggleModeratorModal = () => {
		setShowModeratorModal ( prev => !prev );
	};

	const toggleErrorModal = () => {
		setErrorModal ( prev => !prev );
	};

	if ( !userId || !isNumeric ( userId ) )
		return null;

	return (
		<Presentation
			activeTab = { activeTab }
			activeTabData = { activeTabData }
			errorModal = { errorModal }
			isModerator = { isModerator }
			isUploadingVideo = { isUploadingVideo }
			percentCompleted = { percentCompleted }
			showModeratorModal = { showModeratorModal }
			toggleErrorModal = { toggleErrorModal }
			toggleModeratorModal = { toggleModeratorModal }
			toggleModeratorOption = { toggleModeratorOption }
			userBroadcastDetails = { broadcastDetails }
			userId = { userId }
			userProfile = { profile }
		/>
	);
};

export default UserProfileNew;
